/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/unlock_medium'
export default icon
